export default __webpack_public_path__ + "static/media/traf_team.51c59c44.png";